// Full-document render of the password-reset complete view: PageSkeleton (the
// React document shell) wrapping the account-page layout -- the brand heading,
// the confirmation copy + log-in button, the decorative account image, and the
// customer-service info block. The brand heading + confirmation copy +
// decorative image arrive pre-resolved as props (server-side gettext +
// per-APP_SLUG branding); the customer-service block travels as the
// `cs_info_json` seam.
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetCompleteDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <div className="account-page-title">
                    <h1>{props.page_copy?.page_heading}</h1>
                </div>

                <section className="account-page-container">
                    <div>
                        <h2>{props.complete_text}</h2>
                        <div>
                            <p>{props.body_text}</p>
                            <p>
                                <a href={props.login_url} className="button">
                                    {props.login_label}
                                </a>
                            </p>
                        </div>
                    </div>
                    <div>
                        {props.page_copy?.account_image ? (
                            <img
                                src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                                alt={props.page_copy.account_image_alt}
                            />
                        ) : null}
                    </div>
                </section>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
